import { Component } from '@angular/core';

@Component({
  selector: 'app-horizonair',
  standalone: true,
  imports: [],
  templateUrl: './horizonair.component.html',
  styleUrl: './horizonair.component.scss'
})
export class HorizonairComponent {

}
